    window.enterCosmoCryptApp = async function (targetView) {
        const landingOverlay = document.getElementById('landing-page-overlay');
        // Resolve alias to canonical slug
        const resolved = (window.COSMO_ALIAS_MAP && window.COSMO_ALIAS_MAP[targetView]) || targetView;
        const templateId = resolved + '-template';

        // If template is not in the DOM, fetch it before switching
        if (!document.getElementById(templateId)) {
            try {
                const resp = await fetch('/templates/' + resolved + '.html');
                if (resp.ok) {
                    const html = await resp.text();
                    const el = document.createElement('script');
                    el.type = 'text/plain';
                    el.id = templateId;
                    el.textContent = html;
                    document.body.appendChild(el);
                }
            } catch (e) {
                console.warn('[enterApp] Could not load template:', resolved, e);
            }
        }

        if (targetView && typeof window.switchView === 'function') {
            const switched = window.switchView(targetView);
            if (switched === false) {
                return; // Plan restriction blocked access; upgrade modal handles user feedback.
            }
        }

        if (landingOverlay) {
            landingOverlay.style.transition = 'opacity 0.5s ease';
            landingOverlay.style.opacity = '0';

            // Pause video background of the landing page
            const video = document.getElementById('landing-hero-video');
            if (video) {
                try { video.pause(); } catch (e) { }
            }

            // Remove menu open class
            document.body.classList.remove('landing-menu-open');

            setTimeout(() => {
                landingOverlay.style.display = 'none';
            }, 500);
        }
    };

    document.addEventListener("DOMContentLoaded", () => {
        const video = document.getElementById("landing-hero-video");
        if (!video) return;

        const fadeDuration = 0.5; // duration in seconds
        let rafId = null;

        function updateVideoOpacity() {
            if (video.paused || video.ended) {
                rafId = null;
                return;
            }

            const currentTime = video.currentTime;
            const duration = video.duration;

            if (duration && duration > 0) {
                if (currentTime < fadeDuration) {
                    const opacity = currentTime / fadeDuration;
                    video.style.opacity = Math.min(1, Math.max(0, opacity));
                } else if (currentTime > duration - fadeDuration) {
                    const timeLeft = duration - currentTime;
                    const opacity = timeLeft / fadeDuration;
                    video.style.opacity = Math.min(1, Math.max(0, opacity));
                } else {
                    video.style.opacity = "1";
                }
            }

            rafId = requestAnimationFrame(updateVideoOpacity);
        }

        video.addEventListener("play", () => {
            if (!rafId) {
                rafId = requestAnimationFrame(updateVideoOpacity);
            }
        });

        video.addEventListener("pause", () => {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        });

        video.addEventListener("ended", () => {
            video.style.opacity = "0";
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }

            setTimeout(() => {
                video.currentTime = 0;
                video.play().catch(err => {
                    console.warn("Autoplay or loop play was prevented by browser:", err);
                });
            }, 100);
        });

        video.play().catch(err => {
            console.warn("Direct autoplay prevented. Setting up event listener fallback...", err);
            const startPlay = () => {
                video.play().catch(() => { });
                document.removeEventListener("click", startPlay);
                document.removeEventListener("touchstart", startPlay);
            };
            document.addEventListener("click", startPlay);
            document.addEventListener("touchstart", startPlay);
        });
    });

    document.addEventListener("DOMContentLoaded", () => {
        const menuToggle = document.getElementById('landing-menu-toggle');
        const mobileMenu = document.getElementById('landing-mobile-menu');
        const mobileMenuBackdrop = document.getElementById('landing-mobile-menu-backdrop');
        const drawerSlider = document.getElementById('landing-drawer-slider');
        const drawerCloseBtn = document.getElementById('landing-drawer-close-btn');

        let currentDrawerPage = 0;
        let isProgrammaticLandingBack = false;

        window.openLandingMobileMenu = function () {
            if (document.body.classList.contains('landing-menu-open')) return;
            document.body.classList.add('landing-menu-open');
            mobileMenu?.classList.remove('translate-x-full');
            mobileMenu?.classList.add('translate-x-0');
            mobileMenuBackdrop?.classList.add('menu-backdrop-active');

            // Reset slide
            window.slideLandingDrawerPage(0, false);

            // History push for back button support
            if (!history.state || history.state.landingDrawer !== true) {
                history.pushState({ landingDrawer: true, drawerPage: 0 }, "");
            }

            // Pause landing background video when mobile menu is open
            const heroVideo = document.getElementById('landing-hero-video');
            if (heroVideo) {
                try { heroVideo.pause(); } catch (err) { }
            }
        };

        window.closeLandingMobileMenu = function (fromPop = false) {
            if (!document.body.classList.contains('landing-menu-open')) return;
            document.body.classList.remove('landing-menu-open');
            mobileMenu?.classList.remove('translate-x-0');
            mobileMenu?.classList.add('translate-x-full');
            mobileMenuBackdrop?.classList.remove('menu-backdrop-active');

            if (!fromPop && history.state && history.state.landingDrawer) {
                isProgrammaticLandingBack = true;
                history.back();
            }

            // Resume landing video play
            const heroVideo = document.getElementById('landing-hero-video');
            if (heroVideo) {
                try { heroVideo.play().catch(() => { }); } catch (err) { }
            }
        };

        window.toggleLandingMobileMenu = function () {
            const isOpen = document.body.classList.contains('landing-menu-open');
            if (isOpen) {
                if (currentDrawerPage > 0) {
                    window.slideLandingDrawerPage(0, true);
                } else {
                    window.closeLandingMobileMenu(false);
                }
            } else {
                window.openLandingMobileMenu();
            }
        };

        window.slideLandingDrawerPage = function (pageIndex, pushHistory = true) {
            currentDrawerPage = pageIndex;
            if (drawerSlider) {
                const delay = pageIndex === 0 ? 0 : 150;
                setTimeout(() => {
                    const percentage = -(pageIndex * 25);
                    drawerSlider.style.transform = `translateX(${percentage}%)`;
                }, delay);
            }
            if (pushHistory) {
                if (pageIndex > 0) {
                    if (!history.state || history.state.drawerPage !== pageIndex) {
                        history.pushState({ landingDrawer: true, drawerPage: pageIndex }, "");
                    }
                } else {
                    if (history.state && history.state.landingDrawer && history.state.drawerPage > 0) {
                        isProgrammaticLandingBack = true;
                        history.back();
                    }
                }
            }
        };

        // Popstate listener for Back button navigation
        window.addEventListener('popstate', (e) => {
            if (isProgrammaticLandingBack) {
                isProgrammaticLandingBack = false;
                return;
            }

            if (document.body.classList.contains('landing-menu-open')) {
                if (currentDrawerPage > 0) {
                    window.slideLandingDrawerPage(0, false);
                } else {
                    window.closeLandingMobileMenu(true);
                }
            }
        });

        // ESC key listener
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && document.body.classList.contains('landing-menu-open')) {
                if (currentDrawerPage > 0) {
                    window.slideLandingDrawerPage(0, true);
                } else {
                    window.closeLandingMobileMenu(false);
                }
            }
        });

        window.handleDrawerCloseClick = function () {
            if (currentDrawerPage > 0) {
                window.slideLandingDrawerPage(0, true);
            } else {
                window.closeLandingMobileMenu(false);
            }
        };

        menuToggle?.addEventListener('click', window.toggleLandingMobileMenu);
        mobileMenuBackdrop?.addEventListener('click', () => window.handleDrawerCloseClick());
        drawerCloseBtn?.addEventListener('click', () => window.handleDrawerCloseClick());
    });